import React, { createContext, useContext, ReactNode } from 'react';
import { Reminder } from '../Clients/reminds';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClientContext } from './ApiClient.Context';

interface ContextType {
  data: Reminder[] | undefined;
  deleteReminder: (id: number) => void;
}

const Context = createContext<ContextType | undefined>(undefined);

export const useRemindersContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useRemindersContext must be used within a RemindersProvider');
  }
  return context;
};

interface Props {
  children: ReactNode;
}

export const RemindersProvider: React.FC<Props> = ({ children }) => {
  const { remindersClient } = useApiClientContext();
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: ['reminders'],
    queryFn: () => remindersClient.getReminders(),
  });

  const { mutate } = useMutation({
    mutationFn: (id: number) => remindersClient.deleteReminder(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reminders'] });
    },
    onError: error => {
      console.error('Error deleting grocery item:', error);
    },
  });

  return <Context.Provider value={{ data, deleteReminder: mutate }}>{children}</Context.Provider>;
};
